.toastContainer {
  gap: 16px;
  background: rgb(14 14 14 / 69%);
  backdrop-filter: blur(8px);
  box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 25%) inset;
  align-items: center;
  border-radius: 16px;
  padding: 16px;
  bottom: 20px;
  left: 24px;
  right: 24px;
  position: absolute;
}

@media all and (--reefer-media-tablet-min) {
  .toastContainer {
    position: relative;
    margin: 16px 0px 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
}
